import { Route, Routes } from 'react-router-dom';

import EmailTablePage from '@/modules/Dashboard/Messages/Emails/EmailTablePage/EmailTablePage';
import NewEmailPage from '@/modules/Dashboard/Messages/Emails/NewEmailPage/NewEmailPage';
import SingleSendsPage from '@/modules/Dashboard/Messages/SingleSendsPage';
import NewSMSPage from '@/modules/Dashboard/Messages/SMS/NewSMSPage/NewSMSPage';

export const SingleSends = () => (
  <Routes>
    <Route path="" element={<SingleSendsPage />} />
    <Route path="email" element={<EmailTablePage />} />
    <Route path="email/new" element={<NewEmailPage />} />
    <Route path="sms" element={<SMS />} />
    <Route path="sms/new" element={<NewSMSPage />} />
  </Routes>
);

const SMS = () => <h1>SMS</h1>;
